export default "__VITE_ASSET__CDOraYPT__"